export const updateApplicationState = function updateApplicationState({
    authToken,
    userData,
    projectData
  }) {
    const state = this.getRootState()
    this.call('overwrite', state, {
      authToken
    })
    this.call('overwrite', state, userData)
    // USER-CODE-ORIGIN review N4: stored AS IS (strings) — the shell never
    // revives member-authored project code; the opaque frame does.
    return this.call('overwrite', state, projectData)
  }